import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChatPage from "../pages/ChatPage";
import HomePage from '../pages/HomePage';

export default function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/chat" element={<ChatPage />} />
      </Routes>
    </Router>
  );
}
